import { ApplicationError } from '@/api/ApplicationError';

export interface FunnelApi {
  loading: boolean;
  error: undefined | ApplicationError;
}

function getInitialState(): FunnelApi {
  return {
    loading: false,
    error: undefined,
  };
}

const getters = {
  isFunnelApiLoading: (state: FunnelApi): boolean => state.loading,
  isFunnelApiSuccess: (state: FunnelApi): boolean => !state.loading && !state.error,
  isFunnelApiError: (state: FunnelApi): boolean => !state.loading && !!state.error,
  getFunnelApiError: (state: FunnelApi): undefined | ApplicationError => state.error,
};

const mutations = {
  resetFunnelApiLoading(state: FunnelApi): void {
    state.loading = false;
  },
  setFunnelApiLoading(state: FunnelApi): void {
    state.error = undefined;
    state.loading = true;
  },
  setFunnelApiError(state: FunnelApi, runtimeError: Error): void {
    let error: Error;
    if (runtimeError instanceof ApplicationError) {
      error = runtimeError;
    } else {
      error = ApplicationError.fromRuntimeError(runtimeError);
    }

    state.error = error as any;
    state.loading = false;
  },
  resetFunnelApiStates(state: FunnelApi): void {
    state.error = undefined;
    state.loading = false;
  },
};

const _default = { state: getInitialState, getters, mutations };
export default _default;
